/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from 'styled-components';
import Icon from '../Icon';
import { tokens, orange, inkA } from '../tokens';

// 38x36 ghost action button. Glyph goes orange on hover; accent = orange,
// danger = red (until hovered).
//
// Pass `to` for actions that navigate: the icon renders as a real <Link>
// (an <a href>), so cmd/ctrl-click, middle-click and "Open in new tab"
// all work. Use `onClick` for actions that don't navigate (modals, deletes).
const ActionIcon = ({ icon, title, onClick, to, danger, accent }) => {
  const theme = useTheme();
  const t = tokens(theme);
  const [h, setH] = useState(false);
  const bg = accent
    ? orange(0.12)
    : h
    ? danger
      ? 'rgba(214,58,36,0.12)'
      : inkA(theme, 0.06)
    : 'transparent';
  const col = accent || h ? t.primary : danger ? '#D63A24' : inkA(theme, 0.6);
  const style = {
    width: 38,
    height: 36,
    flexShrink: 0,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 11,
    background: bg,
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    transition: 'background 120ms ease',
  };
  const glyph = <Icon name={icon} size={18} color={col} strokeWidth={2.25} />;
  const hoverProps = {
    onMouseEnter: () => setH(true),
    onMouseLeave: () => setH(false),
  };

  if (to) {
    return (
      <Link
        to={to}
        title={title}
        onClick={onClick}
        {...hoverProps}
        style={{ ...style, textDecoration: 'none' }}
      >
        {glyph}
      </Link>
    );
  }

  return (
    <button
      type="button"
      title={title}
      onClick={onClick}
      {...hoverProps}
      style={style}
    >
      {glyph}
    </button>
  );
};

export default ActionIcon;
